const skipReactionActivitiesMiddleware = () => (next) => (...args) => {
    const [card] = args;
    if (card.activity.type === 'messageReaction') {
        return false;
    }
    return next(...args);
};
export { skipReactionActivitiesMiddleware };
//# sourceMappingURL=skipReactionActivitiesMiddleware.js.map